export const CONFIGURATION_LIST_REQUEST = "CONFIGURATION_LIST_REQUEST";
export const CONFIGURATION_LIST_SUCCESS = "CONFIGURATION_LIST_SUCCESS";

export const CONFIGURATION_READ = 104000;
export const CONFIGURATION_UPDATE = 104001;